import { Component, computed, input } from '@angular/core';
import { Star } from './Star';

@Component({
  selector: 'Stars',
  imports: [Star],
  template: `
    <div class="flex gap-0.5">
      @for (star of fullStars(); track star) {
        <Star></Star>
      }
      @if (hasHalfStar()) {
        <Star [half]="true"></Star>
      }
      @for (star of emptyStars(); track star) {
        <Star [empty]="true"></Star>
      }
    </div>
  `,
})
export class Stars {
  rating = input(10);

  readonly fullStars = computed(() => [...Array(Math.floor(this.rating() / 2)).keys()]);
  readonly hasHalfStar = computed(() => this.rating() % 2 > 0);
  readonly emptyStars = computed(() => [...Array(Math.floor((10 - this.rating()) / 2)).keys()]);
}
